import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Layout, Row, Col, Pagination, Menu, Dropdown, Tooltip } from "antd";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import {
  DeleteTwoTone,
  Done,
  LocalOfferTwoTone,
  Sync,
  PageviewTwoTone,
  MoreVert,
  VpnKeyTwoTone,
  PersonPinCircleTwoTone,
  VisibilityTwoTone,
} from "@material-ui/icons";
import Router from "next/router";
import { find } from "lodash";
import { setKeywords } from "../../store/actions/keywordActions";
import SortKeywords from "./SortKeywords";
import SearchKeywords from "./SearchKeywords";
import KeywordRow from "./KeywordRow";
import RemoveAction from "./RemoveAction";
import UpdateTagsModal from "./UpdateTagsModal";
import RefreshKeywords from "./RefreshKeywords";
import { addTobeRemoved } from "../../store/actions/keywordActions";
import DisallowedForRole from "../Users/DisallowedForRole";
import CardStatsKeywords from "./CardStatsKeywords";
import LCIconButton from "../styles/LCIconButton";
import LCButton from "../styles/LCButton";
import { CSVLink } from "react-csv";

const Keywords = ({ type, pageName }) => {
  const dispatcher = useDispatch();
  const keywordsObj = useSelector((state) => state.keywords);
  const domain = useSelector((state) => state.domains.currentDomain);
  const domains = useSelector((state) => state.domains.domains);
  const currentUser = useSelector((state) => state.auth.user);
  const currentDomain = find(domains, (domainx) => {
    return domainx._id === domain._id;
  });
  const keywords = keywordsObj.keywords;
  const { Content } = Layout;
  // const historyParam = Router.query.history;

  const selectAll = () => {
    const allKeywords = keywordsObj.keywords.map((keywords) => {
      return keywords._id;
    });
    dispatcher(addTobeRemoved(allKeywords));
  };

  const bulkActionMenu = (
    <Menu>
      <Menu.Item
        key="1"
        icon={<Done className="menu-action-item-detail" />}
        onClick={() => selectAll()}
      >
        Select All
      </Menu.Item>
      <Menu.Item key="3" icon={<Sync className="menu-action-item-tag" />}>
        <RefreshKeywords />
      </Menu.Item>
      {currentUser && currentUser.role !== "viewer" && (
        <Menu.Item
          key="2"
          icon={<LocalOfferTwoTone className="menu-action-item-tag" />}
        >
          <UpdateTagsModal />
        </Menu.Item>
      )}
      {currentUser && currentUser.role !== "viewer" && (
        <Menu.Item
          style={{ color: "darkred" }}
          key="4"
          icon={<DeleteTwoTone className="menu-action-item-trash" />}
        >
          <RemoveAction />
        </Menu.Item>
      )}
    </Menu>
  );

  const changePage = (pageNum, pageSize) => {
    dispatcher(
      setKeywords(
        domain._id,
        pageNum,
        keywordsObj.search,
        keywordsObj.sort,
        pageSize
      )
    );
  };

  const tableHeadIconStyles = { fontSize: "26px", color: "#002f53" };
  const tagStyles = {
    display: "inline-block",
    width: 25,
    height: 25,
    background: "#02a2f2",
    color: "#ffffff",
    fontWeight: 600,
    marginRight: 10,
    borderRadius: 20,
    textAlign: "center",
    padding: "0px 8.5px",
  };

  const alternateHeads = () => {
    switch (type) {
      case "history":
        return (
          <>
            <Th className="ant-table-cell text-center">
              <Dropdown.Button
                overlay={bulkActionMenu}
                placement="bottomCenter"
                className="menu-action"
                style={{ top: "5px" }}
                buttonsRender={([leftButton]) => [
                  leftButton,
                  <LCIconButton>
                    <MoreVert />
                  </LCIconButton>,
                ]}
              ></Dropdown.Button>
            </Th>
            <Th className="ant-table-cell">
              <Tooltip title="Keywords">
                <VpnKeyTwoTone style={tableHeadIconStyles} />
              </Tooltip>
              <SortKeywords sort="keyword" />
            </Th>
            <Th className="ant-table-cell text-center">
              <Tooltip title="Tags">
                <LocalOfferTwoTone style={tableHeadIconStyles} />
              </Tooltip>
            </Th>
            <Th className="ant-table-cell text-center">
              <Tooltip title="Search Engine">
                <PageviewTwoTone style={tableHeadIconStyles} />
              </Tooltip>
              <SortKeywords sort="searchEngine" />
            </Th>
            <Th className="ant-table-cell text-center">
              <Tooltip title="Country">
                <PersonPinCircleTwoTone style={tableHeadIconStyles} />
              </Tooltip>
              <SortKeywords sort="country" />
            </Th>
            <Th className="ant-table-cell text-center">
              Rank <SortKeywords sort="rank" />
            </Th>
            <Th className="ant-table-cell text-center">
              Highest Rank <SortKeywords sort="highestRank" />
            </Th>
            <Th className="ant-table-cell text-center">
              Intial Rank <SortKeywords sort="intialRank" />
            </Th>
            <Th className="ant-table-cell text-center">History</Th>
          </>
        );
      case "snapshot":
        return (
          <>
            <Th className="ant-table-cell">
              <Tooltip title="Keywords">
                <VpnKeyTwoTone style={tableHeadIconStyles} />
              </Tooltip>
              <SortKeywords sort="keyword" />
            </Th>
            <Th className="ant-table-cell text-center">
              Rank <SortKeywords sort="rank" />
            </Th>
            <Th className="ant-table-cell text-center">Competition</Th>
            <Th className="ant-table-cell text-center">
              Volume <SortKeywords sort="searchVolume" />
            </Th>
            <Th className="ant-table-cell text-center">
              CPC <SortKeywords sort="cpc" />
            </Th>
            <Th className="ant-table-cell text-center">Checked On</Th>
            <Th className="ant-table-cell text-center">
              <VisibilityTwoTone style={tableHeadIconStyles} />
            </Th>
          </>
        );
      case "competitor":
        return (
          <>
            <Th className="ant-table-cell">
              <Tooltip title="Keywords">
                <VpnKeyTwoTone style={tableHeadIconStyles} />
              </Tooltip>
              <SortKeywords sort="keyword" />
            </Th>
            <Th className="ant-table-cell text-center">
              <Tooltip title="Search Engine">
                <PageviewTwoTone style={tableHeadIconStyles} />
              </Tooltip>
              <SortKeywords sort="searchEngine" />
            </Th>
            <Th className="ant-table-cell text-center">
              <Tooltip title="Country">
                <PersonPinCircleTwoTone style={tableHeadIconStyles} />
              </Tooltip>
              <SortKeywords sort="country" />
            </Th>
            <Th className="ant-table-cell text-center">
              Rank <SortKeywords sort="rank" />
            </Th>
            <Th className="ant-table-cell text-center">
              {" "}
              <span style={tagStyles}>1</span>
            </Th>
            <Th className="ant-table-cell text-center">
              {" "}
              <span style={tagStyles}>2</span>
            </Th>
            <Th className="ant-table-cell text-center">
              {" "}
              <span style={tagStyles}>3</span>
            </Th>
            <Th className="ant-table-cell text-center">
              <span style={tagStyles}>4</span>
            </Th>
          </>
        );
      case "target":
        return (
          <>
            <Th className="ant-table-cell">
              <Tooltip title="Keywords">
                <VpnKeyTwoTone style={tableHeadIconStyles} />
              </Tooltip>
              <SortKeywords sort="keyword" />
            </Th>
            <Th className="ant-table-cell text-center">
              <Tooltip title="Search Engine">
                <PageviewTwoTone style={tableHeadIconStyles} />
              </Tooltip>
              <SortKeywords sort="searchEngine" />
            </Th>
            <Th className="ant-table-cell text-center">
              <Tooltip title="Country">
                <PersonPinCircleTwoTone style={tableHeadIconStyles} />
              </Tooltip>
              <SortKeywords sort="country" />
            </Th>
            <Th className="ant-table-cell text-center">
              Rank <SortKeywords sort="rank" />
            </Th>
            {currentDomain &&
              currentDomain.targets.map((target) => {
                return <Th className="ant-table-cell text-center">{target}</Th>;
              })}
          </>
        );
      default:
        return (
          <>
            <Th className="ant-table-cell text-center">
              <Dropdown.Button
                overlay={bulkActionMenu}
                placement="bottomCenter"
                className="menu-action"
                style={{ top: "5px" }}
                buttonsRender={([leftButton]) => [
                  leftButton,
                  <LCIconButton>
                    <MoreVert />
                  </LCIconButton>,
                ]}
              ></Dropdown.Button>
            </Th>
            <Th className="ant-table-cell">
              <Tooltip title="Keywords">
                <VpnKeyTwoTone style={tableHeadIconStyles} />
              </Tooltip>
              <SortKeywords sort="keyword" />
            </Th>
            <Th className="ant-table-cell">URL</Th>
            <Th className="ant-table-cell text-center">
              <Tooltip title="Tags">
                <LocalOfferTwoTone style={tableHeadIconStyles} />
              </Tooltip>
            </Th>
            <Th className="ant-table-cell text-center">
              <Tooltip title="Search Engine">
                <PageviewTwoTone style={tableHeadIconStyles} />
              </Tooltip>
              <SortKeywords sort="searchEngine" />
            </Th>
            <Th className="ant-table-cell text-center">
              <Tooltip title="Country">
                <PersonPinCircleTwoTone style={tableHeadIconStyles} />
              </Tooltip>
              <SortKeywords sort="country" />
            </Th>
            <Th className="ant-table-cell text-center">
              Rank <SortKeywords sort="rank" />
            </Th>
            <Th className="ant-table-cell text-center">
              Volume <SortKeywords sort="searchVolume" />
            </Th>
            <Th className="ant-table-cell text-center">
              CPC <SortKeywords sort="cpc" />
            </Th>
            <Th className="ant-table-cell text-center">Actions</Th>
          </>
        );
    }
  };

  return (
    <>
      <Layout style={{ background: "transparent" }}>
        {["ranking", "history", "snapshot"].includes(type) ? (
          <CardStatsKeywords keywordsObj={keywordsObj} />
        ) : null}
        <br />
        <SearchKeywords type={type} />
        <br />
        <Content
          className="ant-table-content"
          style={{ minHeight: "88vh", backgroundColor: "#fff" }}
        >
          <Table className="ant-table-thead">
            <Thead className="ant-table-thead">
              <Tr>{alternateHeads()}</Tr>
            </Thead>
            {keywords.length !== 0 ? (
              <Tbody className="ant-table-tbody text-center">
                {keywords.map((keyword) => {
                  return (
                    <KeywordRow
                      keyword={keyword}
                      key={keyword._id}
                      domain={currentDomain}
                      type={type}
                    />
                  );
                })}
              </Tbody>
            ) : (
              <Tbody className="ant-table-tbody">
                <Tr className="ant-table-row ant-table-row-level-0">
                  <Td
                    className="ant-table-cell"
                    colSpan="10"
                    style={{ textAlign: "center", fontWeight: "bold" }}
                  >
                    No Keyword Found!
                  </Td>
                </Tr>
              </Tbody>
            )}
          </Table>
          <Row className="mb-3" justify="center" style={{ paddingTop: "15px" }}>
            <Pagination
              defaultCurrent={keywordsObj.page}
              pageSize={keywordsObj.limit}
              total={keywordsObj.totalDocs}
              onChange={(page, pageSize) => changePage(page, pageSize)}
              showSizeChanger={true}
              pageSizeOptions={[15, 50, 100, 500, 750]}
            />
          </Row>
        </Content>
      </Layout>
    </>
  );
};

export default Keywords;
